module.exports = __webpack_public_path__ + "img/pr-42.0581d1a7.png";